import { formatMoney } from "./money";

export const HelpersPlugin = {
  install(Vue, options) {
    // asd
    this.init_prototype(Vue);
  },
  init_prototype(vue) {
    vue.prototype.$formatMoney = formatMoney;
  }
};
